import { httpGet } from '../../../modules/api/axios_api';
import Constants, { fixProtocol } from '../../../constants/constants';

const BLUEPRINT_URL = `${fixProtocol(Constants.BACKEND_URL)}/restorative-programs/`;

export const getProgram = async (programId: number) => {
  const url = new URL(BLUEPRINT_URL + programId);

  return httpGet(url.href)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw new Error('Error getting program', error);
    });
};
